import { LENS_DATE_END_PARAMETER, LENS_DATE_START_PARAMETER, type LensCard } from '~/types/leLens';

export function missingParameterGuidance(
  parameters: Array<string> | undefined,
  bindings: LensCard['filterBindings'],
  canEdit: boolean,
): { headline: string; subtitle: string; footer: string } | undefined {
  if (!parameters?.length) {
    return undefined;
  }

  const filterParameters = new Set(
    Object.values(bindings ?? {}).flatMap((binding) =>
      binding.type === 'select' && binding.parameter ? [binding.parameter] : [],
    ),
  );
  const isPeriod = (name: string) => name === LENS_DATE_START_PARAMETER || name === LENS_DATE_END_PARAMETER;
  const unbound = parameters.filter((name) => !filterParameters.has(name) && !isPeriod(name));
  if (unbound.length) {
    return {
      headline: 'Query needs configuration.',
      subtitle: `No filter supplies ${unbound.map((name) => `@${name}`).join(', ')}. ${
        canEdit
          ? 'Edit the card to check its query and filter bindings.'
          : 'Ask the owner to check the query and filter bindings.'
      }`,
      footer: 'Missing query parameters',
    };
  }

  const needsPeriod = parameters.some(isPeriod);
  const needsFilters = parameters.some((name) => !isPeriod(name));
  return {
    headline: needsFilters ? 'Choose required filters.' : 'Choose a date range.',
    subtitle: needsPeriod ? 'Open Filters above and set the period and any unselected filters.' : 'Open Filters above.',
    footer: needsFilters ? 'Waiting for filters' : 'Waiting for a date range',
  };
}
